import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation } from "../../common/validation.common";

export namespace AuditorValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const Create = defineValidation(
        v.object({
            name: baseVals.string(),
            username: baseVals.username(),
            password: baseVals.password(),
        }),
    );

    export const Update = defineValidation(
        v.object({
            name: v.exactOptional(baseVals.string()),
            username: v.exactOptional(baseVals.username()),
            password: v.exactOptional(baseVals.password()),
        }),
    );
}
